import { render } from "./WawaSlider.vue?vue&type=template&id=1c8264c8"
import script from "./WawaSlider.vue?vue&type=script&lang=js"
export * from "./WawaSlider.vue?vue&type=script&lang=js"

import "./WawaSlider.vue?vue&type=style&index=0&id=1c8264c8&lang=css"
script.render = render

export default script